import Main from "./Main";
import Pumpkins from "./Utils/Pumpkins";
import Sound from "./Utils/Sound";
import Events from "./Utils/EventLite";
import {CONFIG} from "./config";
var pumpkins= new Pumpkins(CONFIG.year);
var sound = new Sound();
    sound.init(
    ['assets/sounds.ogg', 'assets/sounds.mp3'],
    {
        Intro: [0, 7406, false],
        Start: [7406, 5593, false],
        AmbientLoop: [13000,7300, true],
        Select: [20300, 2300, false],
        Vote: [22705, 6290, false],
        Restart: [29000, 3824, false]
    });
var mainMusic = new Sound();
    mainMusic.init(
        ['assets/StingyJackTrack.mp3']
    );
    mainMusic.howlerInstance.play();
    Events.on("stopMainMusic", ()=>{
        mainMusic.howlerInstance.stop();
    });

var ambientMusic = new Sound();
    ambientMusic.init([
        'assets/ambientLoop.mp3'
    ]);
    Events.on("playAmbientLoop", ()=>{
        ambientMusic.howlerInstance.play();
    });

var app = new Main();
app.goto("Title");









// WEBPACK FOOTER //
// ./src/App.js